
// don't love that we have to do these next two lines here, but jest bombs out on this component otherwise
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VCard from 'vuetify/lib/components/VCard';
import Vue from 'vue';
import { cardShadow } from '@/core/new-crm-ui-colors';
export default Vue.extend({
    name: 'BaseCard',
    extends: VCard,
    props: {
        // set the default elevation value here. It actually is already defaulted to 2 in Vuetify, but
        // with this we can set it for all our cards if it's ever desired to be changed
        elevation: {
            type: Number,
            default: 0
        },
        borderRadius: {
            type: [Boolean, String],
            default: () => '18px'
        },
        boxShadow: {
            type: String,
            default: () => '0px 16px 32px -12px ' + cardShadow
        }
    },
    computed: {
        // add crm-card to the css class of the rendered element
        classes(): object {
            return {
                // ...VCard.options.computed.classes.call(this),
                'base-card': true
            };
        },
        styles(): object {
            return {
                borderRadius: this.borderRadius,
                boxShadow: this.boxShadow,
                width: '100%'
            };
        }
    },
    render(this: Vue & any, h) {
        return h(
            'div',
            {
                staticClass: 'v-card',
                class: this.classes,
                style: this.styles,
                on: this.$listeners
            },
            this.$slots.default
        );
    }
});
